var convert = require('./convert'),
    func = convert('sortBy', require('../sortBy'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/lodash/fp/sortBy.js
// module id = 2409
// module chunks = 0